import dynamic from 'next/dynamic';
import { DashboardContentTilesProps } from './DashboardContentTiles.types';

export const ReslinkDashboardContentTiles = dynamic<{ model: DashboardContentTilesProps }>(() =>
  import('./DashboardContentTiles').then(mod => mod.DashboardContentTiles)
);
